/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });

  // console.log("parseTime," + time + " " + time_str)
  return time_str;
}

export function formatDate(date, format) {
  if (!date) return;
  if (!format) format = "yyyy-MM-dd";
  switch (typeof date) {
    case "string":
      date = new Date(date.replace(/-/, "/"));
      break;
    case "number":
      date = new Date(date);
      break;
  }
  if (!(date instanceof Date)) return;
  var dict = {
    yyyy: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    H: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    MM: ("" + (date.getMonth() + 101)).substr(1),
    dd: ("" + (date.getDate() + 100)).substr(1),
    HH: ("" + (date.getHours() + 100)).substr(1),
    mm: ("" + (date.getMinutes() + 100)).substr(1),
    ss: ("" + (date.getSeconds() + 100)).substr(1),
  };

  const time_str = format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function () {
    return dict[arguments[0]];
  });
  // console.log("formatDate,"+date+", format:"+format+","+time_str)
  return time_str;
}

/**
 * 时间戳格式化
 * @param {*}} time
 * @param {*} cFormat
 * @returns
 */
export function longToDateFormat(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  if (!cFormat) {
    cFormat = "{y}-{m}-{d} {h}:{i}:{s}";
  }
  var date = new Date();
  date.setTime(time);
  return parseTime(date, cFormat);
}

/**
 * 两个时间大小
 * @param {*} sTime
 * @param {*} eTime
 */
export function timeCheck(sTime, eTime) {
  var stime = Date.parse(sTime);
  var etime = Date.parse(eTime);
  return etime - stime;
}

// 比较两个日期 相差秒数
export function seconddifference(sDate1, sDate2) {
  var dateSpan, iSecond;
  sDate1 = Date.parse(sDate1);
  sDate2 = Date.parse(sDate2);
  dateSpan = sDate2 - sDate1;
  dateSpan = Math.abs(dateSpan);
  iSecond = Math.floor(dateSpan / 1000);
  return iSecond;
}

// 比较两个日期 相差天数
export function datedifference(sDate1, sDate2) {
  var dateSpan, iDays;
  sDate1 = Date.parse(sDate1);
  sDate2 = Date.parse(sDate2);
  dateSpan = sDate2 - sDate1;
  dateSpan = Math.abs(dateSpan);
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
  return iDays;
}

/**
 *比较两个日期 相差天数
 * @param {*} sDate1
 * @param {*} sDate2
 * @returns 返回值为为负数
 */
export function dateDifference(sDate1, sDate2) {
  var dateSpan, iDays;
  sDate1 = Date.parse(sDate1);
  sDate2 = Date.parse(sDate2);
  dateSpan = sDate2 - sDate1;
  iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
  return iDays;
}

/**
 *比较两个日期 相差月数
 * @param {*} date1
 * @param {*} date2
 */
export function monthDifference(date1, date2) {
  date1 = date1.split("-");
  // 得到月数
  date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);
  // 拆分年月日
  date2 = date2.split("-");
  // 得到月数
  date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
  var months = Math.abs(date1 - date2);

  return months;
}

/**
 * 计算两个日期时间相差的年数、月数、天数、小时数、分钟数、秒数
 * DIFFTIME(开始时间,结束时间,[单位])，单位可以是 "y" 、"M"、"d"、"h"、"m"、"s"'
 * DIFFTIME('2019-6-30 13:20:00', '2020-10-01 11:20:32', 's')
 */
export function DiffTime(startTime, endTime, unit) {
  // 判断当前月天数
  function getDays(mouth, year) {
    let days = 30;
    if (mouth === 2) {
      days = year % 4 === 0 ? 29 : 28;
    } else if (
      mouth === 1 ||
      mouth === 3 ||
      mouth === 5 ||
      mouth === 7 ||
      mouth === 8 ||
      mouth === 10 ||
      mouth === 12
    ) {
      // 月份为：1,3,5,7,8,10,12 时，为大月.则天数为31；
      days = 31;
    }
    return days;
  }

  const start = new Date(startTime);
  const end = new Date(endTime);
  // 计算时间戳的差
  const diffValue = end - start;
  // 获取年
  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  // 获取月
  const startMouth = start.getMonth() + 1;
  const endMouth = end.getMonth() + 1;
  // 获取日
  const startDay = start.getDate();
  const endDay = end.getDate();
  // 获取小时
  const startHours = start.getHours();
  const endHours = end.getHours();
  // 获取分
  const startMinutes = start.getMinutes();
  const endMinutes = end.getMinutes();
  // 获取秒
  const startSeconds = start.getSeconds();
  const endSeconds = end.getSeconds();
  // 下方注释两行为调试用
  // console.log('start:', startYear, startMouth, startDay, startHours, startMinutes, startSeconds)
  // console.log('end:', endYear, endMouth, endDay, endHours, endMinutes, endSeconds)
  if (unit === "y" || unit === "M") {
    // 相差年份月份
    const diffYear = endYear - startYear;
    // 获取当前月天数
    const startDays = getDays(startMouth, startYear);
    const endDays = getDays(endMouth, endYear);
    const diffStartMouth =
      (startDays -
        (startDay +
          (startHours * 60 + startMinutes + startSeconds / 60) / 60 / 24 -
          1)) /
      startDays;
    const diffEndMouth =
      (endDay + (endHours * 60 + endMinutes + endSeconds / 60) / 60 / 24 - 1) /
      endDays;
    const diffMouth =
      diffStartMouth +
      diffEndMouth +
      (12 - startMouth - 1) +
      endMouth +
      (diffYear - 1) * 12;
    if (unit === "y") {
      return Math.round(((diffMouth / 12) * 100) / 100);
    } else {
      return Math.round(diffMouth);
    }
  } else if (unit === "d") {
    const d = parseInt(diffValue / 1000 / 60 / 60 / 24);
    return d;
  } else if (unit === "h") {
    const h = parseInt(diffValue / 1000 / 60 / 60);
    return h;
  } else if (unit === "m") {
    const m = parseInt(diffValue / 1000 / 60);
    return m;
  } else if (unit === "s") {
    const s = parseInt(diffValue / 1000);
    return s;
  } else {
    console.log("请输入正确的单位");
  }
}

/**
 * 获取两个时间月份数
 */
export function getMonths(start, end, day) {
  var result = [];
  var starts = start.split("-");
  var ends = end.split("-");
  var staYear = starts[0] * 1;
  var staMon = starts[1] * 1 < 10 ? starts[1] : starts[1];
  var endYear = ends[0] * 1;
  var endMon = ends[1] * 1 < 10 ? ends[1] : ends[1];
  end = new Date(end);
  var date;
  while (staYear <= endYear) {
    if (staYear === endYear) {
      while (staMon <= endMon - 1) {
        staMon++;
        if (staMon < 10) {
          date = getMonthStr(staYear, staMon, day, end);
          if (date != null) {
            result.push(date);
          }
        } else {
          date = getMonthStr(staYear, staMon, day, end);
          if (date != null) {
            result.push(date);
          }
        }
      }
      staYear++;
    } else {
      staMon++;
      if (staMon > 12) {
        staMon = 1;
        staYear++;
      }
      if (staMon < 10) {
        date = getMonthStr(staYear, staMon, day, end);
        if (date != null) {
          result.push(date);
        }
      } else {
        date = getMonthStr(staYear, staMon, day, end);
        if (date != null) {
          result.push(date);
        }
      }
    }
  }
  return result;
}

/**
 * 获取两个时间之间的 月份数 包括当前月
 * @param {*} start
 * @param {*} end
 * @param {*} day
 * @returns
 */
export function getMonths2(start, end, day) {
  var result = [];
  var now = new Date(start);
  var sDate = new Date(start);
  var eDate = new Date(end);
  sDate.setDate(day);
  while (sDate.getTime() < eDate.getTime()) {
    if (sDate.getTime() > now.getTime()) {
      result.push(parseTime(sDate, "{y}-{m}-{d}"));
      // result.push(getMonthStr(sDate.getFullYear(),sDate.getMonth()+1,sDate.getDay() ))
    }
    sDate.setDate(day);
    sDate.setMonth(sDate.getMonth() + 1);
    if (sDate.getDate() != day) {
      sDate = getMonth(sDate.getFullYear(), sDate.getMonth(), 0);
    }
  }
  result.push(parseTime(eDate, "{y}-{m}-{d}"));
  return result;
}

/**
 * 获取月份的天数
 * @param {*} year 年
 * @param {*} month 月份
 * @returns
 */
export function getDateDay(date) {
  var d = new Date(date);
  d.setMonth(d.getMonth() + 1);
  d.setDate(0);
  return d.getDate();
}

/**
 *获取月份 日期 超出正确日期 则获取当月最后一天
 例如 2021-02-31  改成为 2020-02-28
 * @param {*} year
 * @param {*} month
 * @param {*} day
 */
export function getMonth(year, month, day) {
  var date = new Date();
  date.setFullYear(year);
  date.setDate(day);
  date.setMonth(parseInt(month - 1));
  if (date.getMonth() == month) {
    date.setDate(0);
  }
  return date;
}

/**
 *获取月份 日期 超出正确日期 则获取当月最后一天
 例如 2021-02-31  改成为 2020-02-28
 * @param {*} year
 * @param {*} month
 * @param {*} day
 */
export function getMonthStr(year, month, day, end) {
  var date = new Date();
  date.setFullYear(year);
  date.setDate(day);
  date.setMonth(parseInt(month - 1));
  if (date.getMonth() == month) {
    date.setDate(0);
  }
  return parseTime(date, "{y}-{m}-{d}");
}

/**
 * 时间 日期 向后退
 * @param {*} value
 * @param {*} day
 * @returns
 */
export function getDayAfter(value, day) {
  var date = new Date(value);
  date.setDate(date.getDate() + parseInt(day));
  return parseTime(date, "{y}-{m}-{d}");
}

/**
 * 时间 月份向后推
 * @param date
 * @param num
 */
export function getMonthAfter(value, num, day) {
  var date = new Date(value);
  date.setMonth(date.getMonth() + parseInt(num));
  if (day) {
    date.setDate(date.getDate() + day);
  }
  return parseTime(date, "{y}-{m}-{d}");
}

/**
 * 时间 月份向后推 如果2月这样子
 * 1月31日=》向后台推一个月 则为 2月31日 显示日期 会是 3月01日
 * 所以要修正显示 2月28日
 * @param date
 * @param num
 */
export function getMonthAfter2(value, num) {
  var date = new Date(value);
  var month = (date.getMonth() + parseInt(num)) % 12;

  date.setMonth(date.getMonth() + parseInt(num));
  if (date.getMonth() - 1 == month) {
    // 月份超过日期 月份 则显示上个月最后一日
    date.setDate(0);
  }
  return parseTime(date, "{y}-{m}-{d}");
}
/**
 * 时间 月份向前推
 * @param date
 * @param num
 */
export function getMonthBefore(date, num) {
  var dates = date.split("-");
  var year_ = dates[0] * 1;
  var month_ = dates[1] * 1;
  var i = num;
  var result = [];
  while (i > 0) {
    i--;
    var month = month_;
    var year = year_;
    if (i == 0) {
      result.push(dates[0] + "-" + dates[1]);
    } else {
      if (month_ < num) {
        month += 12;
        year--;
        month -= i;
        if (month < 10) {
          result.push(year + "-0" + month);
        } else {
          if (month == 13) {
            month = 1;
            result.push(year + "-0" + month);
          } else {
            result.push(year + "-" + month);
          }
        }
      } else {
        month -= i;
        if (month < 10) {
          result.push(year + "-0" + month);
        } else {
          result.push(year + "-" + month);
        }
      }
    }
  }
  return result;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split("&");
  searchArr.forEach((v) => {
    const index = v.indexOf("=");
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/**
 * 获取 uuid
 */
export function getUuid() {
  // 32长度
  var len = 32;
  // 16进制
  var radix = 16;
  var chars =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
  var uuid = [];
  var i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    var r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

/**
 * 获取当月第一天和最后一天
 * @returns {string[]}
 */
export function getMonthFirstLastDay(nowDate) {
  const now = nowDate ? new Date(nowDate) : new Date(); // 当前日期
  const nowMonth = now.getMonth(); // 当前月
  const nowYear = now.getFullYear(); // 当前年
  // 本月的开始时间
  const monthStartDate = new Date(nowYear, nowMonth, 1);
  // 本月的结束时间
  const monthEndDate = new Date(nowYear, nowMonth + 1, 0);
  return [monthStartDate, monthEndDate];
}

/**
 * 获取月份的最后一天
 * @param {*} nowDate
 * @returns
 */
export function getMonthLastDay(nowDate) {
  const now = nowDate ? new Date(nowDate) : new Date(); // 当前日期
  const nowMonth = now.getMonth(); // 当前月
  const nowYear = now.getFullYear(); // 当前年
  // 本月的结束时间
  const monthEndDate = new Date(nowYear, nowMonth + 1, 0);
  return monthEndDate;
}

/**
 * 千分位格式化 000,000
 * @param cellValue
 * @returns {*}
 */
export function thousandFormat(cellValue) {
  if (cellValue > 0) {
    cellValue += "";
    if (!cellValue.includes(".")) cellValue += ".";
    return cellValue
      .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
        return $1 + ",";
      })
      .replace(/\.$/, "");
  } else {
    return cellValue;
  }
}

/**
 * 天数转成年,月,日
 * @param days
 * @returns {function(*): {months: number, days: number, years: number}}
 */
export const calculateTimimg = (d) => {
  let months = 0;
  let years = 0;
  let days = 0;
  while (d) {
    if (d >= 365) {
      years++;
      d -= 365;
    } else if (d >= 30) {
      months++;
      d -= 30;
    } else {
      days++;
      d--;
    }
  }
  return {
    years,
    months,
    days,
  };
};

/**
 * 时间计算
 * type：计算的单位 y年 M月 d日 h小时 m分钟 s秒
 * num：增加的数量
 * fmt：返回的时间格式 为空返回:{y}-{m}-{d} {h}:{i}:{s}
 */
export function calculation(date, type, num, fmt) {
  if (!date) {
    return "";
  }
  if (!fmt) {
    fmt = "{y}-{m}-{d} {h}:{i}:{s}";
  }
  const theDate = new Date(date);
  let sdtime = new Date(date).getTime();
  if (type == "y") {
    sdtime = theDate.setFullYear(theDate.getFullYear() + num);
  } else if (type == "M") {
    sdtime = theDate.setMonth(theDate.getMonth() + num);
  } else if (type == "d") {
    sdtime = theDate.setDate(theDate.getDate() + num);
  } else if (type == "h") {
    sdtime = theDate.setHours(theDate.getHours() + num);
  } else if (type == "m") {
    sdtime = theDate.setMinutes(theDate.getMinutes() + num);
  } else if (type == "s") {
    sdtime = theDate.setSeconds(theDate.getSeconds() + num);
  }
  return parseTime(new Date(sdtime), fmt);
}

/**
 * 检查密码强度
 * @param value
 * @returns
 */
export function checkPassword(password = "", minLength = 8, maxLength = 32) {
  const complexity = {
    score: 0,
    msg: "",
  };

  // 条件1: 密码长度
  if (password.length >= minLength && password.length <= maxLength) {
    complexity.score += 1;
  } else {
    complexity.score = 1;
    complexity.msg =
      "密码长度应至少为" + minLength + "个字符,且小于" + maxLength + "字符";
    return complexity;
  }
  // 条件2: 是否包含小写字母
  if (/.*[a-z]/.test(password)) {
    complexity.score += 1;
  }
  // 条件3: 是否包含大写字母
  if (/.*[A-Z]/.test(password)) {
    complexity.score += 1;
  }
  // 条件4: 是否包含数字
  if (/.*\d/.test(password)) {
    complexity.score += 1;
  }
  // 条件5: 是否包含特殊字符
  if (/.*[\W_]/.test(password)) {
    complexity.score += 1;
  }

  //评估密码强度
  switch (complexity.score) {
    case 5:
      complexity.msg = "强密码！";
      break;
    case 4:
      complexity.msg = "中等强度的密码。";
      break;
    case 3:
      complexity.msg = "中等强度的密码。";
      break;
    case 2:
      complexity.msg = "弱密码，建议增加更多的字符种类。";
      break;
    default:
      complexity.msg = "密码太弱，建议增加长度和字符种类。";
  }
  return complexity;
}

// 引入Three.js

/**
 * 经纬度坐标转球面坐标
 * @param {地球半径} R
 * @param {经度(角度值)} longitude
 * @param {维度(角度值)} latitude
 */
export function lon2xyz(R, longitude, latitude) {
  var lon = (longitude * Math.PI) / 180; //转弧度值
  var lat = (latitude * Math.PI) / 180; //转弧度值
  lon = -lon; // three.js坐标系z坐标轴对应经度-90度，而不是90度

  // 经纬度坐标转球面坐标计算公式
  var x = R * Math.cos(lat) * Math.cos(lon);
  var y = R * Math.sin(lat);
  var z = R * Math.cos(lat) * Math.sin(lon);
  // 返回球面坐标
  return {
    x: x,
    y: y,
    z: z,
  };
}

export const isType = function (type, value) {
  return Object.prototype.toString.call(value) === `[object ${type}]`;
};
/**
 * 判断是否为对象
 */
export const isObject = function (value) {
  return isType('Object', value);
};
/**
 * @description deepCloneMap() 深拷贝-最终版：解决循环引用的问题
 * @param {*} target 对象
 * @example
 *      const obj1 = {
 *          a: 1,
 *          b: ["e", "f", "g"],
 *          c: { h: { i: 2 } },
 *      };
 *      obj1.b.push(obj1.c);
 *      obj1.c.j = obj1.b;
 *
 *      const obj2 = deepCloneMap(obj1);
 *      obj2.b.push("h");
 *      console.log(obj1, obj2);
 *      console.log(obj2.c === obj1.c);
 */
export function deepCloneMap(target, map = new Map()) {
  // target 不能为空，并且是一个对象
  if (target != null && isObject(target)) {
    // 在克隆数据前，进行判断是否克隆过,已克隆就返回克隆的值
    let cache = map.get(target);
    if (cache) {
      return cache;
    }
    // 判断是否为数组
    const isArray = Array.isArray(target);
    let result = isArray ? [] : {};
    // 将新结果存入缓存中
    cache = map.set(target, result);
    // 如果是数组
    if (isArray) {
      // 循环数组，
      target.forEach((item, index) => {
        // 如果item是对象，再次递归
        result[index] = deepCloneMap(item, cache);
      });
    } else {
      // 如果是对象
      Object.keys(target).forEach((key) => {
        if (isObject(result[key])) {
          result[key] = deepCloneMap(target[key], cache);
        } else {
          result[key] = target[key];
        }
      });
    }
    return result;
  } else {
    return target;
  }
}

export function deepMerge(target, source) {
  target = deepCloneMap(target);
  for (let key in source) {
    if (key in target) {
      // 对象的处理
      if (isObject(source[key])) {
        if (!isObject(target[key])) {
          target[key] = source[key];
        } else {
          target[key] = deepMerge(target[key], source[key]);
        }
      } else {
        target[key] = source[key];
      }
    } else {
      target[key] = source[key];
    }
  }
  return target;
}
// 随机数
export const random = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
/**
 * 获取样式
 * @param {*} el
 * @param {*} ruleName
 * @returns
 */
export function getStyle(el, ruleName) {
  return window.getComputedStyle(el)[ruleName];
}
